/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import {TooltipExtraRow, TooltipValue} from 'components/charts/multiline-chart/model/tooltip';

import {roundFloatNumber, divideBySpaces} from 'helpers/numberHelpers';

import getValueWithToken from '../../helpers/getValueWithToken';

export interface GetTooltipPointPlanOptions {
  data: CommonChartData;
  roundNumberBy: number;
  token?: string;
}

const getTooltipPointPlan = ({
  data,
  token,
  roundNumberBy,
}: GetTooltipPointPlanOptions): TooltipExtraRow[] => {
  const {line, lineSecondary} = data;

  if (line === undefined) {
    return [];
  }

  const roundedValuePrimary = roundFloatNumber(line, roundNumberBy);
  const valuePrimary = divideBySpaces(roundedValuePrimary);

  const result: TooltipValue = {
    primary: getValueWithToken({
      value: valuePrimary,
      token,
    }),
  };

  if (lineSecondary !== undefined) {
    const roundedValueSecondary = roundFloatNumber(lineSecondary, roundNumberBy);
    const valueSecondary = divideBySpaces(roundedValueSecondary);

    result.secondary = getValueWithToken({
      value: valueSecondary,
      token,
    });
  }

  return [
    {
      label: 'План',
      value: result,
    },
  ];
};

export default getTooltipPointPlan;
